import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Url_Friendly_String } from 'src/app/modules/shared/helpers/helper';
import { Category } from 'src/app/modules/shared/models/products.model';

@Component({
  selector: 'product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss'],
})
export class ProductCategoriesComponent {
  @Input() categories: Category[];

  constructor(private router: Router) {}

  goToCategory(category: Category) {
    this.router.navigate([
      '/category',
      category.id,
      this.getUrlFriendlyName(category.name),
    ]);
  }

  private getUrlFriendlyName(name: string) {
    return Url_Friendly_String(name);
  }
}
